<template>
    <div class="cinema-info-page page">
        <div class="info">
            <div class="movie-info">
                <img class="movie-img" :src="movieInfo.pic" />
                <div class="movie-content">
                    <div class="name">
                        <span class="movie-name">{{ movieInfo.name }}</span>
                        <span class="hint" :class="{ highlight: movieInfo.d != '' && movieInfo.d != '2D' }">
                            <div class="txt treed" v-if="movieInfo.d">{{ movieInfo.d }}</div>
                            <div class="txt imax" v-if="movieInfo.im">{{ movieInfo.im }}</div>
                        </span>
                    </div>
                    <div class="grade">
                        <template v-if="movieInfo.grade > 0">
                            <span>评分</span>
                            <span class="tint">{{ movieInfo.grade }}</span>
                        </template>
                        <template v-if="movieInfo.like > 0">
                            <span>{{ movieInfo.likeText }}人想看</span>
                        </template>
                    </div>
                    <div class="performer">{{ movieInfo.cast }}</div>
                    <div class="type">
                        <span>{{ movieInfo.filmTypes }}</span>
                        <span class="tint">{{ movieInfo.duration }}分钟</span>
                    </div>
                    <div class="show-time">{{ movieInfo.publishDate }}上映</div>
                </div>
            </div>
            <div
                class="film-materials"
                v-if="movieInfo.intro"
                @click="openMovieInfo"
                :class="{ shorten: !isOpenMovieInfo }"
            >
                {{ movieInfo.intro }}
            </div>
            <div
                class="more-btn"
                :class="{ shorten: !isOpenMovieInfo }"
                @click="openMovieInfo"
                v-if="movieInfo.intro"
            ></div>
        </div>
        <div class="date-list flex" :class="{ 'more-date': dateList.length > 3 }">
            <div
                class="date-item"
                :class="{ select: index == dateIndex }"
                v-for="(item, index) in dateList"
                @click="switchDate(index)"
                :key="index"
            >
                <div class="text">
                    <span class="week">{{ item.week }}</span>
                    <span class="date">{{ item.month }}/{{ item.day }}</span>
                </div>
            </div>
        </div>
        <div class="select-bar">
            <div class="s-wrap" v-if="!searchStatus">
                <div class="cell">
                    <div class="picker" @click="openRegion">
                        <span>{{ regionList[regionIndex].name || '全城' }}</span>
                        <img class="img" :src="require('@/assets/icons/icon-down-triangle.png')" />
                    </div>
                </div>
                <div class="cell">
                    <div class="picker" @click="openBrand">
                        <span>{{ brandList[brandIndex].name || '品牌' }}</span>
                        <img class="img" :src="require('@/assets/icons/icon-down-triangle.png')" />
                    </div>
                </div>
                <div class="img-box" @click="openSearch">
                    <img class="img-s" :src="require('@/assets/icons/icon-search.png')" />
                </div>
            </div>
            <div class="search" v-else>
                <div class="wrap">
                    <div class="ipt-box">
                        <img class="img-s" :src="require('@/assets/icons/icon-search.png')" />
                        <input class="ipt" placeholder="请输入影院名称或地址" v-model="searchText" />
                        <img
                            class="img-r"
                            v-if="searchText.length > 0"
                            @click="clearText"
                            :src="require('@/assets/icons/icon-clear.png')"
                        />
                    </div>
                    <div class="cancel" @click="closeSearch">
                        <span>取消</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="list iphone-x-adaptation">
            <div class="cell" v-for="(item, index) in cinemaList" @click="toCinema(item)" :key="index">
                <div class="name">
                    <div class="txt">{{ item.name }}</div>
                    <span class="distance">{{ item.distance }}</span>
                </div>
                <div class="addr">
                    <span class="txt">{{ item.address }}</span>
                </div>
                <div class="sessions" v-if="item.recentStage">
                    <span class="txt">
                        近期场次
                        <span class="txt-right" v-for="(v, i) in item.recentStage.split('丨')" :key="i">
                            {{ v }}
                        </span>
                    </span>
                </div>
                <div class="lab-list">
                    <div class="lab-item subsidy" v-if="item.showType == 1">
                        <img class="image" src="~@/assets/icons/icon-subsidy.png" />
                    </div>
                    <template v-if="item.enableCompetition == 1">
                        <div class="lab-item red">精品影院</div>
                        <div class="lab-item blue">极速出票</div>
                        <div class="lab-item green">出票率高</div>
                    </template>
                </div>
            </div>
            <div class="noList" v-if="isLoading && cinemaList.length == 0">影院加载中...</div>
            <div class="noList load-error" v-else-if="loadError && cinemaList.length == 0">
                <div>{{ loadError }}</div>
                <button type="button" @click="reloadForCity">重新加载</button>
            </div>
            <div class="noList" v-else-if="cinemaList.length == 0">无搜索结果</div>
        </div>
        <div class="location iphone-x-adaptation">
            <div>
                <span class="txt">定位：{{ currentCityName }}</span>
                <div class="rs-lc" :class="{ loading: againLocationStatus }" @click="againLocation">重新定位</div>
            </div>
        </div>
        <Scroll :onBottom="onBottom" />
        <Share v-if="!$store.state.common.platformId" />
    </div>
</template>
<script>
import monent from 'moment';
import {
    GET_MOVIE_INFO,
    GET_MOVIE_INFO_DAY,
    GET_CINEMA_BRAND_LIST,
    GET_CITY_REGION_LIST,
    GET_MOVIE_FOR_CINEMA_LIST,
} from 'api';
import { PAGE_CINEMA_INFO, PAGE_MAIN_MOVIE, PAGE_ROOT } from 'page';
import Share from '@/components/share';
import Scroll from '@/components/scroll';
import number from '@/lib/number';
export default {
    data() {
        return {
            id: 0,
            pageIndex: 1,
            pageSize: 20,
            movieInfo: {},
            isOpenMovieInfo: false,
            dateList: [],
            dateIndex: 0,
            brandList: [{}],
            brandIndex: 0,
            regionList: [{}],
            regionIndex: 0,
            searchStatus: false,
            searchText: '',
            cinemaList: [],
            isBottom: false,
            isLoading: false,
            loadError: '',
            requestId: 0,
            againLocationStatus: false,
            isLoad: false,
        };
    },
    computed: {
        cityId() {
            return this.$store.getters.getCurrentLocation.city.id || 0;
        },
        cityName() {
            return this.$store.getters.getCurrentLocation.city.name || '未定位';
        },
        currentCityName() {
            return this.$store.state.location.currentLocation.city.name || '未定位';
        },
        lon() {
            return this.$store.getters.getCurrentLocation.lon;
        },
        lat() {
            return this.$store.getters.getCurrentLocation.lat;
        },
    },
    watch: {
        cityId(val) {
            if (val) {
                this.reloadForCity();
            }
        },
        searchText(val) {
            this.$util.debounce(this.reloadList, 300, false)();
        },
    },
    components: {
        Scroll,
        Share,
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path == PAGE_MAIN_MOVIE || from.path == PAGE_ROOT) {
                vm.$util.debounce(vm.init)();
            } else if (vm.cinemaList.length == 0) {
                vm.$util.debounce(vm.init)();
            }
        });
    },
    created() {
        this.$util.debounce(this.init)();
    },
    methods: {
        init() {
            this.id = this.$route.query.movieId;
            if (this.id) {
                localStorage.setItem('QZ_CINEMA_ID', this.id);
            } else {
                this.id = localStorage.getItem('QZ_CINEMA_ID');
            }
            this.getMovieInfo();
            this.getBrandList();
            if (this.cityId) {
                this.reloadForCity();
            }
        },
        reloadForCity() {
            if (!this.cityId) {
                return Promise.resolve();
            }
            this.requestId++;
            this.pageIndex = 1;
            this.dateIndex = 0;
            this.dateList = [];
            this.regionIndex = 0;
            this.regionList = [{ name: this.cityName, id: '' }];
            this.cinemaList = [];
            this.isBottom = false;
            this.loadError = '';
            return Promise.all([this.getDateList(), this.getArea()]).then(() => this.getList());
        },
        reloadList() {
            this.pageIndex = 1;
            this.cinemaList = [];
            this.isBottom = false;
            return this.getList();
        },
        // 获取电影信息
        getMovieInfo() {
            this.$util
                .post(GET_MOVIE_INFO, {
                    id: this.id,
                })
                .then(res => {
                    if (res.success) {
                        this.vTypeIMax(res.data);
                        res.data.actorList &&
                            (res.data.cast = res.data.actorList
                                .map(v => {
                                    return v.scName;
                                })
                                .join(' '));
                        if (res.data.like) {
                            if (res.data.like > 10000) {
                                res.data.likeText = (1 * number.operation(`${res.data.like}/10000`)).toFixed(2) + '万';
                            } else {
                                res.data.likeText = res.data.like.toLocaleString();
                            }
                        }
                        res.data.publishDate = monent(res.data.publishDate).format('YYYY.MM.DD');
                        this.movieInfo = res.data;
                    }
                });
        },
        // 获取品牌列表
        getBrandList() {
            this.$util.post(GET_CINEMA_BRAND_LIST).then(res => {
                if (res.success) {
                    res.data.unshift({
                        name: '品牌',
                        id: '',
                        keyWord: '',
                    });
                    this.brandList = res.data;
                }
            });
        },
        // 重新获取定位
        againLocation() {
            if (!this.againLocationStatus) {
                this.againLocationStatus = true;
                this.$util.getLocation({
                    callback: res => {
                        this.againLocationStatus = false;
                        if (res.success) {
                            const previousCityId = this.cityId;
                            this.$store.commit('removeSelectLocation');
                            if (res.data.city.id == previousCityId) {
                                this.reloadForCity();
                            }
                        }
                    },
                });
            }
        },
        // 获取日期列表
        getDateList() {
            const cityId = this.cityId;
            return this.$util
                .post(GET_MOVIE_INFO_DAY, {
                    cityId,
                    movieId: this.id,
                })
                .then(res => {
                    if (res.success && cityId == this.cityId) {
                        for (let i = 0; i < res.data.length; i++) {
                            const item = res.data[i];
                            item.time = `${item.month}月${item.day}日`;
                        }
                        this.dateList = res.data;
                    } else if (cityId == this.cityId) {
                        this.loadError = (res && res.message) || '场次日期加载失败，请稍后重试。';
                    }
                });
        },
        // 获取下级区域
        getArea() {
            const cityId = this.cityId;
            return this.$util
                .post(GET_CITY_REGION_LIST, {
                    id: cityId,
                })
                .then(res => {
                    if (res.success && cityId == this.cityId) {
                        res.data.unshift({
                            name: this.cityName,
                            id: '',
                        });
                        this.regionList = res.data;
                    }
                });
        },
        // 获取影院列表
        getList() {
            if (!this.cityId || this.isLoading || !this.dateList[this.dateIndex]) {
                return Promise.resolve();
            }
            const {
                id,
                lon,
                lat,
                cityId,
                regionList,
                regionIndex,
                dateList,
                dateIndex,
                brandList,
                brandIndex,
                searchText,
                pageIndex,
                pageSize,
            } = this;
            const region = regionList[regionIndex] || {};
            const date = dateList[dateIndex] || {};
            const requestId = ++this.requestId;
            this.isLoading = true;
            this.loadError = '';
            return this.$util
                .post(GET_MOVIE_FOR_CINEMA_LIST, {
                    lon,
                    lat,
                    date: date.date,
                    cityId,
                    regionId: region.id || null,
                    movieId: id,
                    cinemaName: searchText || (brandIndex == 0 ? '' : brandList[brandIndex].keyWord),
                    pageIndex,
                    pageSize,
                    cinemaShowType: this.$store.getters.getExposeMethod.cinemaShowType || null,
                })
                .then(res => {
                    if (requestId != this.requestId) {
                        return;
                    }
                    if (res.success) {
                        if (res.data.length < pageSize) {
                            this.isBottom = true;
                        } else {
                            this.isBottom = false;
                        }
                        this.cinemaList = [...this.cinemaList, ...res.data];
                    } else {
                        this.loadError = (res && res.message) || '影院加载失败，请稍后重试。';
                    }
                })
                .catch(error => {
                    if (requestId == this.requestId) {
                        console.error('movie-cinema-list', error);
                        this.loadError = '影院加载失败，请稍后重试。';
                    }
                })
                .then(() => {
                    if (requestId == this.requestId) {
                        this.isLoading = false;
                    }
                });
        },
        // 打开区列表
        openRegion() {
            this.$picker.open({
                list: this.regionList,
                keyName: 'name',
                confirm: (item, index) => {
                    this.regionIndex = index;
                    this.$picker.close();
                    this.reloadList();
                },
            });
        },
        // 打开品牌列表
        openBrand() {
            this.$picker.open({
                list: this.brandList,
                keyName: 'name',
                confirm: (item, index) => {
                    this.brandIndex = index;
                    this.$picker.close();
                    this.reloadList();
                },
            });
        },
        // 切换日期
        switchDate(index) {
            this.dateIndex = index;
            this.reloadList();
        },
        // 打开电影详情信息
        openMovieInfo() {
            this.isOpenMovieInfo = !this.isOpenMovieInfo;
        },
        // 格式化
        vTypeIMax(res) {
            var versionTypes = res.versionTypes;
            if (!versionTypes) {
                res.d = '';
                res.im = '';
            } else {
                if (versionTypes.split(' ').length == 2) {
                    res.d = versionTypes.split(' ')[0];
                    res.im = versionTypes.split(' ')[1];
                } else {
                    if (versionTypes.indexOf('5D') >= 0) {
                        res.d = '5D';
                    } else if (versionTypes.indexOf('4D') >= 0) {
                        res.d = '4D';
                    } else if (versionTypes.indexOf('3D') >= 0) {
                        res.d = '3D';
                    } else if (versionTypes.indexOf('2D') >= 0) {
                        res.d = '2D';
                    } else {
                        res.d = '';
                    }
                    if (versionTypes.indexOf('IMAX') >= 0) {
                        res.im = 'IMAX';
                    } else if (versionTypes.indexOf('中国巨幕') >= 0) {
                        res.im = '中国巨幕';
                    } else {
                        res.im = '';
                    }
                }
            }
        },
        // 打开搜索
        openSearch() {
            this.searchStatus = true;
        },
        // 清空
        clearText() {
            this.searchText = '';
        },
        // 关闭
        closeSearch() {
            this.searchStatus = false;
            this.clearText();
        },
        // 去影院
        toCinema(item) {
            console.log(this.dateList, this.dateIndex);
            this.$util.pageJump(PAGE_CINEMA_INFO, {
                titleName: item.name,
                movieId: this.id,
                dateIndex: this.dateIndex,
                dateText: this.dateList[this.dateIndex].month + '-' + this.dateList[this.dateIndex].day,
                cinemaId: item.id,
            });
        },
        // 触底事件
        onBottom() {
            if (this.isBottom || this.isLoading) {
                return;
            }
            this.pageIndex++;
            this.getList();
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
.cinema-info-page {
    flex-direction: column;
    width: 100%;
    .info {
        margin: 0 .pxToRem(30) [];
        margin-top: .pxToRem(20) [];
        padding-bottom: .pxToRem(54) [];
        background: white;
        box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
        border-radius: .pxToRem(40) [];
        .movie-info {
            padding-top: .pxToRem(40) [];
            padding-bottom: .pxToRem(40) [];
            display: flex;
            .movie-img {
                margin-left: .pxToRem(30) [];
                width: .pxToRem(180) [];
                height: .pxToRem(240) [];
                border-radius: .pxToRem(16) [];
            }
        }
        .movie-content {
            margin-left: .pxToRem(30) [];
            width: .pxToRem(410) [];
            .name {
                display: flex;
                line-height: .pxToRem(44) [];
                font-size: .pxToRem(40) [];
                color: rgba(0, 0, 0, 0.9);
                font-weight: bold;
                margin-bottom: .pxToRem(30) [];
                .hint {
                    display: flex;
                    box-sizing: border-box;
                    padding: 0 .pxToRem(10) [];
                    margin-left: .pxToRem(20) [];
                    height: .pxToRem(34) [];
                    line-height: .pxToRem(34) [];
                    box-sizing: border-box;
                    border: .pxToRem(2) [] solid #313131;
                    font-size: .pxToRem(20) [];
                    border-radius: .pxToRem(8) [];
                    white-space: nowrap;
                    .txt {
                        float: left;
                    }
                    .treed {
                        margin-right: .pxToRem(6) [];
                    }
                    &.highlight {
                        color: #f8c32f;
                        border: .pxToRem(2) [] solid #f8c32f;
                    }
                }
            }
            .grade,
            .performer,
            .type,
            .show-time {
                line-height: .pxToRem(44) [];
                font-size: .pxToRem(28) [];
                color: rgba(0, 0, 0, 0.5);
            }
            .grade {
                .tint {
                    margin-left: .pxToRem(4) [];
                    margin-right: .pxToRem(20) [];
                    color: @theme_color_first;
                    font-size: .pxToRem(30) [];
                    font-weight: bold;
                }
            }
            .type {
                .tint {
                    margin-left: .pxToRem(20) [];
                }
            }
        }
        .film-materials {
            line-height: .pxToRem(38) [];
            font-size: .pxToRem(24) [];
            color: rgba(0, 0, 0, 0.5);
            padding: .pxToRem(20) [] .pxToRem(30) [] 0;
            &.shorten {
                height: .pxToRem(76) [];
                .overflow(2);
            }
            &::after {
                content: ' ';
                position: absolute;
                top: 0;
                left: .pxToRem(30) [];
                right: .pxToRem(30) [];
                height: .pxToRem(1) [];
                background: rgba(0, 0, 0, 0.15);
            }
        }
        .more-btn {
            position: absolute;
            bottom: 0;
            right: 0;
            width: .pxToRem(88) [];
            height: .pxToRem(44) [];
            background: rgba(0, 0, 0, 0.15);
            border-radius: .pxToRem(40) [] 0 .pxToRem(40) [] 0;
            &.shorten {
                &:after {
                    transform: translate(-50%, -50%);
                }
            }
            &:after {
                content: ' ';
                .base-center;
                .sq(32);
                transform: translate(-50%, -50%) rotate(180deg);
                background: url('~@/assets/icons/icon-down-32x32.png');
                background-size: cover;
                transition: all 0.4s;
            }
        }
    }

    .date-list {
        justify-content: space-around;
        height: .pxToRem(88) [];
        margin: 0 .pxToRem(30) [];
        .date-item {
            flex: 1;
            text-align: center;
            height: .pxToRem(88) [];
            line-height: .pxToRem(88) [];
            font-size: .pxToRem(28) [];
            color: rgba(0, 0, 0, 0.5);
            .text {
                display: inline-block;
            }
            .week {
                margin-right: .pxToRem(10) [];
                font-size: .pxToRem(26) [];
            }
            .date {
                font-size: .pxToRem(28) [];
            }
            &.select {
                color: rgba(0, 0, 0, 0.9);
                font-weight: bold;
                .text {
                    &:after {
                        content: ' ';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        height: .pxToRem(4) [];
                        background: #f8c32f;
                    }
                }
            }
        }
        &.more-date {
            display: block;
            justify-content: flex-start;
            white-space: nowrap;
            overflow-x: auto;
            .date-item {
                display: inline-block;
                margin-right: .pxToRem(60) [];
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        &:after {
            content: ' ';
            position: absolute;
            bottom: 0;
            left: .pxToRem(40) [];
            right: .pxToRem(40) [];
            height: .pxToRem(1) [];
            background: rgba(0, 0, 0, 0.1);
        }
    }

    .search {
        height: .pxToRem(88) [];
        box-sizing: border-box;
        padding: .pxToRem(11) [] 0;
        .wrap {
            height: .pxToRem(66) [];
            display: flex;
            flex-direction: row;
            .ipt-box {
                display: flex;
                flex-direction: row;
                background: white;
                height: .pxToRem(66) [];
                border-radius: .pxToRem(40) [];
                flex: 1;
                align-items: center;
            }
            .cancel {
                padding-left: .pxToRem(20) [];
                line-height: .pxToRem(66) [];
                color: #f7b500;
                font-size: .pxToRem(30) [];
                text-align: center;
            }
            .ipt {
                background: rgba(0, 0, 0, 0);
                flex: 1;
                height: .pxToRem(40) [];
                line-height: .pxToRem(40) [];
                padding-left: .pxToRem(20) [];
                padding-right: .pxToRem(10) [];
                font-size: .pxToRem(28) [];
            }
            .img-s {
                .sq(32);
                margin-left: .pxToRem(20) [];
            }
            .img-r {
                .sq(32);
                margin-right: .pxToRem(20) [];
            }
        }
    }
    .select-bar {
        padding: 0 .pxToRem(30) [];
        .s-wrap {
            display: flex;
            flex-direction: row;
            height: .pxToRem(88) [];
            line-height: .pxToRem(88) [];
        }
        .cell {
            width: .pxToRem(230) [];
            text-align: center;
            position: relative;
            .img {
                .sq(32);
                vertical-align: middle;
                margin-left: .pxToRem(24) [];
                margin-top: .pxToRem(-4) [];
                line-height: 0;
            }
            .picker {
                font-size: .pxToRem(28) [];
                color: rgba(0, 0, 0, 0.9);
            }
        }
        .img-box {
            flex: 1;
            .img-s {
                .base-center-y;
                right: .pxToRem(0) [];
                padding: .pxToRem(28) [];
                .sq(32);
                line-height: 0;
            }
        }
    }
    .list {
        padding-left: .pxToRem(30) [];
        padding-right: .pxToRem(30) [];
        border-bottom: .pxToRem(78) [] solid rgba(0, 0, 0, 0);
        .cell {
            padding: .pxToRem(30) [];
            margin-bottom: .pxToRem(20) [];
            background: white;
            box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
            border-radius: .pxToRem(40) [];
            .name {
                font-size: .pxToRem(30) [];
                line-height: .pxToRem(40) [];
                font-weight: bold;
                display: flex;
                .txt {
                    flex: 1;
                    box-sizing: border-box;
                    max-width: .pxToRem(690) [];
                    display: inline-block;
                }
                .distance {
                    padding-left: .pxToRem(30) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    &::before {
                        content: ' ';
                        position: absolute;
                        top: .pxToRem(8) [];
                        left: 0;
                        .sq(24);
                        background: url('~@/assets/icons/icon-address.png');
                        background-size: cover;
                    }
                }
            }
            .addr {
                color: rgba(0, 0, 0, 0.5);
                font-size: .pxToRem(24) [];
                margin-top: .pxToRem(20) [];
                line-height: .pxToRem(36) [];
                .txt-right {
                    margin-left: .pxToRem(20) [];
                }
            }
            .sessions {
                color: rgba(0, 0, 0, 0.5);
                font-size: .pxToRem(24) [];
                margin-top: .pxToRem(4) [];
                line-height: .pxToRem(36) [];
                .txt-right {
                    margin-left: .pxToRem(6) [];
                }
            }
            .lab-list {
                display: flex;
                align-items: center;
                margin-top: .pxToRem(10) [];
                font-size: 0;
                .lab-item {
                    display: inline-block;
                    height: .pxToRem(34) [];
                    margin-right: .pxToRem(10) [];
                    line-height: .pxToRem(34) [];
                    padding: 0 .pxToRem(16) [];
                    box-sizing: border-box;
                    font-size: .pxToRem(20) [];
                    border-radius: .pxToRem(8) [];
                    border: .pxToRem(1) [] solid rgba(0, 0, 0, 0);
                    &.subsidy {
                        width: .pxToRem(88) [];
                        height: .pxToRem(34) [];
                        padding: 0;
                        .image {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    &.red {
                        color: #f7b500;
                        border: .pxToRem(1) [] solid #f8c32f;
                    }
                    &.blue {
                        color: #92a7f3;
                        border: .pxToRem(1) [] solid #92a7f3;
                    }
                    &.green {
                        color: #49c376;
                        border: .pxToRem(1) [] solid #49c376;
                    }
                }
            }
        }
    }

    .location {
        position: fixed;
        width: 100vw;
        line-height: .pxToRem(78) [];
        background: #f0f0f0;
        left: 0px;
        bottom: 0px;
        color: rgba(0, 0, 0, 0.9);
        font-size: .pxToRem(26) [];
        padding-left: .pxToRem(30) [];
        padding-right: .pxToRem(30) [];
        box-sizing: border-box;
        z-index: 10;
        .img {
            .sq(32);
        }
        .txt {
            height: .pxToRem(78) [];
            line-height: .pxToRem(78) [];
            padding-left: .pxToRem(42) [];
            &::before {
                content: ' ';
                .base-center-y;
                left: 0;
                margin-top: .pxToRem(-2) [];
                .sq(32);
                background: url('~@/assets/icons/icon-address.png');
                background-size: cover;
            }
        }
        .rs-lc {
            float: right;
            height: .pxToRem(78) [];
            line-height: .pxToRem(78) [];
            padding-right: .pxToRem(40) [];
            &::after {
                content: ' ';
                .base-center-y;
                right: .pxToRem(0) [];
                margin-top: .pxToRem(-2) [];
                .sq(32);
                background: url('~@/assets/icons/icon-rotate.png');
                background-size: cover;
            }
            &.loading {
                &::after {
                    background: url('~@/assets/icons/icon-rotate-loading.png');
                    background-size: cover;
                }
            }
        }
    }
    .noList {
        text-align: center;
        margin-top: 100px;
        color: rgba(153, 153, 153, 1);
        font-size: .pxToRem(30) [];
        &.load-error {
            line-height: .pxToRem(44) [];
            button {
                min-width: .pxToRem(180) [];
                height: .pxToRem(68) [];
                margin-top: .pxToRem(24) [];
                padding: 0 .pxToRem(28) [];
                color: #ffffff;
                font-size: .pxToRem(26) [];
                border: 0;
                border-radius: .pxToRem(34) [];
                background: @theme_color_first;
            }
        }
    }
}
</style>
